export default __webpack_public_path__ + "static/media/item1.a954e47c.png";